import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import styled from "styled-components";
import { Colors } from "../../config";
import OnBoardingHeader from "./OnBoardingHeader";
import OnBoradingSubHeader from "./OnBoradingSubHeader";
import AirplaneIcon from "../../assets/Icons/AirplaneIcon";

const SecondCarousal = () => {
  return (
    <BoxContainer>
      <ImageContainer>
        <AirplaneIcon />
      </ImageContainer>
      <OnBoardingHeader header="Request for Ticket" />
      <SubTextContainer>
        <OnBoradingSubHeader
          color={Colors.brandOne}
          header="Ready to book your ticket?"
        />
        <br></br>
        <OnBoradingSubHeader
          color={Colors.ashBlue}
          header="Enter your annual or business travel details, including including cities, preferred airline, travel dates and leave request for business trip."
        />
      </SubTextContainer>
    </BoxContainer>
  );
};

const BoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* border-radius: 5px;
  padding: 20px; */
  align-items: center;
  border-radius: 1.25rem;
  /* @media only screen and (max-width: 478px) {
    width: 15.625rem;
  } */
  /* max-height: 43.75rem;
  margin-left: 40rem;
  margin-right: 40rem; */
`;

const ImageContainer = styled.div`
  align-items: center;
  justify-content: center;
  width: 89rem;
  height: 19rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  /* @media only screen and (max-width: 478px) {
    width: 15.625rem;
  } */
  object-fit: contain;
`;
const SubTextContainer = styled.div`
  /* display: flex; */
  flex-direction: column;
  margin-bottom: 2rem;
  max-width: 28rem;
  @media only screen and (max-width: 478px) {
    width: 20rem;
  }
`;
export default SecondCarousal;
